import {
  Board,
  BoardHeader, BoardSearchResult,
  BoardSearchResultTitle,
  BoardTableContainer,
  inputStyle,
  SearchButton,
  SearchInput, selectStyle
} from "../../assets/GlobalStyles";
import Select from "react-select";
import Table from "../../components/table";

import React, {useEffect, useState} from "react";
import {atom, useAtom} from "jotai";
import {dataTotalInfo} from "../../components/common/entity";
import CreateAdminModal from "../../components/common/CreateAdminModal";
import {selAdminList} from "../../services/Platform/ManageAdminAxios";
import {
  columnAdminData,
  searchAccountInfo,
  selectAccountUseInfo
} from "./entity/Common";
import styled from "styled-components";

const UserInfoList = atom([])
export default function PlatformAdmin(){
  const [searchAccountInfoState ,setSearchAccountInfoState] = useState(searchAccountInfo)
  const [accountUseYnState]=useState(selectAccountUseInfo)
  const [userInfoList, setUserInfoList] = useAtom(UserInfoList)
  const [totalInfo,setTotalInfo] = useState(dataTotalInfo)

  useEffect(()=>{
    selAdminList(searchAccountInfoState).then(response =>{
      if(response !== null){
        setUserInfoList(response?.content)
        setTotalInfo({
          totalCount: response?.totalElements,
          totalPages: response?.totalPages,
          currentPage:response?.pageNumber
        })
      }
    })
  },[])

  /**
   * 매체 타입 변경
   * @param mediaType
   */
  const handleMediaType =(mediaType) =>{
    setSearchAccountInfoState({
      ...searchAccountInfoState,
      mediaType: mediaType.value
    })
  }


  /**
   * 검색 타입 선택
   * @param mediaSearchType
   */
  const handleMediaSearchType =(mediaSearchType) =>{
    setSearchAccountInfoState({
      ...searchAccountInfoState,
      mediaSearchType: mediaSearchType.value,
      siteName: mediaSearchType.value !== null ? searchAccountInfoState.siteName : '',
      username: mediaSearchType.value !== null ? searchAccountInfoState?.username: '',
      phoneNumber: mediaSearchType.value !== null ? searchAccountInfoState.phoneNumber: '',
      searchText: mediaSearchType.value !== null ? searchAccountInfoState?.searchText: ''
    })
  }
  /**
   * 계정 사용여부
   * @param accountUseYn
   */
  const handleSelectAccountUseYn =(activeYn) =>{
    setSearchAccountInfoState({
      ...searchAccountInfoState,
      activeYn: activeYn.value
    })
  }
  /**
   * 검색버튼
   */
  const searchUserList =() =>{
    selAdminList(searchAccountInfoState).then(response =>{
      if(response){
        setUserInfoList(response?.content)
        setTotalInfo({
          totalCount: response?.totalElements,
          totalPages: response?.totalPages,
          currentPage:response?.pageNumber
        })
      }
    })
  }

  /**
   * 검색어 입력
   * @param event
   */
  const handleSearchName =(event) =>{
    if(searchAccountInfoState.mediaSearchType ==='MEDIA_NAME'){
      setSearchAccountInfoState({
        ...searchAccountInfoState,
        siteName: event.target.value,
        username:'',
        phoneNumber:'',
        searchText:event.target.value
      })
    }else if(searchAccountInfoState.mediaSearchType ==='MEDIA_ID'){

      setSearchAccountInfoState({
        ...searchAccountInfoState,
        username: event.target.value,
        siteName: '',
        phoneNumber:'',
        searchText:event.target.value
      })
    }else if(searchAccountInfoState.mediaSearchType ==='PHONE'){
      setSearchAccountInfoState({
        ...searchAccountInfoState,
        siteName: '',
        username:'',
        phoneNumber: event.target.value,
        searchText:event.target.value
      })
    }
  }
  return(<>
    <Board>
      <BoardHeader>관리자 관리</BoardHeader>
      <BoardSearchDetail>
        <RowSpan>
          <ColSpan2>
            <ColTitle><span>활성화 여부</span></ColTitle>
            <Select styles={selectStyle}
                    options={accountUseYnState}
                    placeholder={'선택'}
                    value={searchAccountInfoState.activeYn !== ''  ? accountUseYnState.find(type => type.value === searchAccountInfoState.activeYn) : accountUseYnState[0]}
                    onChange={handleSelectAccountUseYn}
            />
          </ColSpan2>
          <ColFraction>
            <SearchButton onClick={()=>searchUserList()}>검색</SearchButton>
          </ColFraction>
        </RowSpan>
      </BoardSearchDetail>
    </Board>
    <Board>
      <BoardSearchResult>
          <RowSpan style={{justifyContent: 'flex-end'}}>
            <CreateAdminModal formType={'admin'} title={'관리자 추가'} buttonText={'관리자 추가'}/>
          </RowSpan>
        <Table columns={columnAdminData}
               totalCount={[totalInfo.totalCount, '관리자']}
               data={userInfoList !== null ? userInfoList : []}/>
      </BoardSearchResult>
    </Board>
      </>
  )
}
const RowSpan = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  margin-top: 25px;
`

 const ColSpan1 = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 25%;
  gap: 10px;
  & > div:last-child {
    position: relative;
    width: 100%;
  }
`

 const ColSpan2 = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 50%;
  gap: 10px;
  & > div:last-child {
    position: relative;
    width: 100%;
  }
`

 const ColSpan3 = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 75%;
  gap: 10px;
  & > div:last-child {
    position: relative;
    width: 100%;
  }
`

 const ColSpan4 = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
  & > div:last-child {
    position: relative;
    width: 100%;
  }
`

 const ColFraction = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 33.333333%;
  gap: 10px;
  & > div:last-child {
    position: relative;
    width: 100%;
  }
`
 const ColTitle = styled.div`
  padding: 0 10px;
  min-width: 65px;
  text-align: left;
  white-space: nowrap;
`
const BoardSearchDetail = styled.div`
  padding: 10px 0;
`
